<template>
    <div>
        <div class="">
            <!-- shape Hero -->
            <section class="section-shaped my-0">
                <div class="shape shape-style-1 shape-default shape-skew">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </div>
                <div v-if="successMessage != null" class="container">
                    <base-alert type="primary" dismissible>
                        <span class="alert-inner--text"> {{successMessage}}</span>
                        <button type="button" class="close" data-dismiss="alert" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </base-alert>
                </div>
                <div class="container shape-container d-flex mb-5">
                    <div class="col px-0">
                    <a-spin :spinning="spinning" >
                        <div class="row">
                            <div class="col col-xs-6 col-sm-6 col-md-6">
                            <a-popover trigger="click"  placement="bottom">
                                <template slot="content">
                                    <blogger-button class="share-button--circle share-button--outline" btnText/>
                                    <digg-button class="share-button--circle share-button--outline" btnText/>
                                    <evernote-button class="share-button--circle share-button--outline" btnText/>
                                    <br>
                                    <facebook-button class="share-button--circle share-button--outline" btnText/>
                                    <whats-app-button class="share-button--circle share-button--outline" btnText/>
                                    <email-button class="share-button--circle share-button--outline" btnText/>
                                    <br>
                                    <instapaper-button class="share-button--circle share-button--outline" btnText/>
                                    <pinterest-button class="share-button--circle share-button--outline" btnText/>
                                    <tumblr-button class="share-button--circle share-button--outline" btnText/>
                                    <br>
                                    <twitter-button class="share-button--circle share-button--outline" btnText/>
                                    <telegram-button class="share-button--circle share-button--outline" btnText/>
                                    <viber-button class="share-button--circle share-button--outline" btnText/>
                                    <br>
                                    <linked-in-button class="share-button--circle share-button--outline" btnText/>
                                    <live-journal-button class="share-button--circle share-button--outline" btnText/>
                                    <odnoklassniki-button class="share-button--circle share-button--outline" btnText/>
                                    <br>
                                    <pocket-button class="share-button--circle share-button--outline" btnText/>
                                    <reddit-button class="share-button--circle share-button--outline" btnText/>
                                    <renren-button class="share-button--circle share-button--outline" btnText/>
                                    <br>
                                    <vkontakte-button class="share-button--circle share-button--outline" btnText/>
                                    <weibo-button class="share-button--circle share-button--outline" btnText/>
                                    <xing-button class="share-button--circle share-button--outline" btnText/>
                                </template>
                                <a class=" p-1 m-2 rounded" style="position: absolute;z-index: 1;height: fit-content;background:#21252996">
                                    <a-icon type="share-alt" :style="{ fontSize: '30px', color: '#ffffff7d' }"/>
                                </a>
                            </a-popover>
                                <div class="card">
                                    <img v-if="product.filename!=null && product.filename!=''" class="img img-responsive" width = "100%" :src="imageUrl+'/'+product.filename" alt="">
                                    <img  v-else  class="img img-responsive" width = "100%" src="http://localhost:3026/product_images/product-default.png" alt="">
                                </div>
                            </div>
                            <div class="col col-xs-6 col-sm-6 col-md-6">
                                <h1 class="display-3 ">{{product.name}}
                                </h1>
                                <span class="">&#8369;{{formatPrice(product.retail_price)}}</span>
                                <hr class="mt-2 bg-white mb-2">
                                <div class="m-0 row">
                                    <div class="col col-xs-3 col-sm-3 col-md-3 pl-0 pt-2">
                                        <div class="form-group has-label">
                                            <label class="form-control-label ">
                                                Quantity
                                                <span>:</span>
                                            </label>
                                            <div class="input-group mb-3">
                                                <div class="input-group-prepend">
                                                    <button type="button" class="btn btn-secondary btn-sm rounded-circle" style="background:#F0F0F5" :disabled="quantity<=1" @click="updateQty(-1)">
                                                        <i class="fas fa-minus"></i>
                                                    </button>
                                                </div>
                                                <input type="number" class="form-control form-control-sm border-0  text-center quantity font-weight-bold" style="background: transparent;" :value="quantity" @change="changeQty">
                                                <div class="input-group-append">
                                                    <button type="button" class="btn btn-secondary btn-sm rounded-circle" style="background:#F0F0F5" @click="updateQty(1)">
                                                        <i class="fas fa-plus"></i>
                                                    </button>
                                                </div>
                                              </div>
                                            
                                            <!-- <a-input-number :default-value="1" @change="updateQty" class="w-100 pr-1" :min="1" :max="10" /> -->
                                        </div>
                                    </div>
                                </div>
                                    <!-- <base-input class="mt-3 col-md-8 pr-0" type="number" v-model="product.quantity" min="1" max="10" required/> -->
                                <div class="m-0 row mt-2" v-if="product.product_type=='M'">
                                    <div class="col-md-4 pl-0" v-show="product.colors.length>0">
                                        <label class="form-control-label ">
                                            Color
                                        </label>
                                        <select class="form-control" data-toggle="select" title="Color" v-model="selectedColor" data-live-search="true" data-live-search-placeholder="Color">
                                            <option v-for="(color,colorIndex) in product.colors" :value="color.id">{{color.name}}
                                                <span v-if="colorIndex == 0 && selectedColor == null" class="d-none">{{selectedColor = color.id}}</span>
                                            </option>
                                        </select>
                                    </div>
                                    <div class="col-md-4 pl-0" v-show="product.sizes.length>0">
                                        <label class="form-control-label ">
                                            Size
                                        </label>
                                        <select class="form-control" data-toggle="select" title="Size" v-model="selectedSize" data-live-search="true" data-live-search-placeholder="Size">
                                            <option v-for="(size,sizeIndex) in product.sizes" :value="size.id" :disabled="size.disabled">{{size.name}}
                                                <span v-if="sizeIndex == 0 && selectedSize==null" class="d-none">{{selectedSize = size.id}}</span>
                                            </option>
                                        </select>
                                    </div>
                                    <div class="col-md-4 "/>
                                </div>
                                <div class="m-0 row" v-if="product.product_type=='M' && product.designs.length>0">
                                    <div class="col-md-8 mt-2 pl-0">
                                        <label class="form-control-label ">
                                            Design
                                        </label>
                                        <select class="form-control" data-toggle="select" title="Design" v-model="selectedDesign" data-live-search="true" data-live-search-placeholder="Design">
                                            <option v-for="(design,designIndex) in product.designs" :value="design.id" :disabled="design.disabled">{{design.name}}
                                                <span  v-if="designIndex == 0 && selectedDesign==null" class="d-none">{{selectedDesign = design.id}}</span>
                                            </option>
                                        </select>
                                    </div>
                                    <div class="col-md-4 pr-0"/>
                                </div>
                                <div class="m-0 mt-1 row">
                                    <div class="col-xs-6 col-sm-6 col-md-6 pl-0 pt-2">
                                        <base-button tag="a" href="#" type="primary" class="text-uppercase w-100" @click.prevent="buyItNow">
                                            Buy It Now
                                        </base-button>
                                    </div>
                                    <div class="col-xs-2 col-sm-2 col-md-2 pl-0 pt-2">
                                        <base-button tag="a" href="#" type="secondary" class="text-uppercase w-100" @click.prevent="addToCart">
                                            <i class="fa fa-shopping-cart"></i>
                                        </base-button>
                                    </div>
                                    <div class="col-xs-4 col-sm-4 col-md-4"/>
                                </div>
                            </div>
                        </div>
                    </a-spin>
                    </div>
                </div>
            </section>
            <!-- 1st Hero Variation -->
        </div>
    </div>
</template>
<script>
import secureStorage from '../../controllers/secureStorage.js'
import HTTPRequest from '../../controllers/httpRequest.js'
import { mapState, mapActions } from 'vuex'
import BloggerButton from "vue-share-buttons/src/components/BloggerButton";
import DiggButton from "vue-share-buttons/src/components/DiggButton";
// import EvernoteButton from "vue-share-buttons/src/components/EvernoteButton";
import FacebookButton from "vue-share-buttons/src/components/FacebookButton";
import InstapaperButton from "vue-share-buttons/src/components/InstapaperButton";
import LinkedInButton from "vue-share-buttons/src/components/LinkedInButton";
import LiveJournalButton from "vue-share-buttons/src/components/LiveJournalButton";
import OdnoklassnikiButton from "vue-share-buttons/src/components/OdnoklassnikiButton";
import PinterestButton from "vue-share-buttons/src/components/PinterestButton";
import PocketButton from "vue-share-buttons/src/components/PocketButton";
import RedditButton from "vue-share-buttons/src/components/RedditButton";
import RenrenButton from "vue-share-buttons/src/components/RenrenButton";
import TumblrButton from "vue-share-buttons/src/components/TumblrButton";
import TwitterButton from "vue-share-buttons/src/components/TwitterButton";
import VkontakteButton from "vue-share-buttons/src/components/VkontakteButton";
import WeiboButton from "vue-share-buttons/src/components/WeiboButton";
import XingButton from "vue-share-buttons/src/components/XingButton";
import TelegramButton from "vue-share-buttons/src/components/TelegramButton";
import EmailButton from "vue-share-buttons/src/components/EmailButton";
import ViberButton from "vue-share-buttons/src/components/ViberButton";
import WhatsAppButton from "vue-share-buttons/src/components/WhatsAppButton";
export default {
    components: {
        HTTPRequest,
        BloggerButton,
        DiggButton,
        EvernoteButton,
        FacebookButton,
        InstapaperButton,
        LinkedInButton,
        LiveJournalButton,
        OdnoklassnikiButton,
        PinterestButton,
        PocketButton,
        RedditButton,
        RenrenButton,
        TumblrButton,
        TwitterButton,
        VkontakteButton,
        WeiboButton,
        XingButton,
        TelegramButton,
        ViberButton,
        WhatsAppButton,
        EmailButton,
    },
    computed: {
        ...mapState(['endPoint', 'parameters','publicUrl'])
    },
    data() {
        return {
            product:{},
            OrderListData:[],
            successMessage:null,
            checkoutOrderListData:[],
            spinning:false,
            selectedDesign:null,
            selectedSize:null,
            selectedColor:null,
            salesChannelId:null,
            imageUrl:null,
            quantity:1,
            customerLoginStatus:null,
            storeDetails:null,
        }
    },
    mounted: async function(){
        var autoLogin = secureStorage.getItem("ecomLoggedIn")
        if(autoLogin == true){
            this.imageUrl = this.publicUrl + 'product_images'
            this.$emit('showFooterAndHeader', event)
            this.$emit('hideSearchInput', event)
            this.salesChannelId = secureStorage.getItem("SalesChannelDetails").id
            this.getProduct()
            this.storeDetails = secureStorage.getItem("SalesChannelDetails")
            this.customerLoginStatus = secureStorage.getItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-CustomerLoginStatus")
            this.OrderList()
        }else{
            this.$router.push({ name: 'loading_screen', params: { returnUrl: 'catalog', storeId:this.$route.params.storeId }})
        }
    },
    watch:{
        selectedColor : function(){
            this.product.sizes.forEach((size)=>{
                size.disabled = true;
            })
            this.product.designs.forEach((design)=>{
                design.disabled = true;
            })
            this.product.colors.forEach((color)=>{
                color.disabled = true;
            })
            this.product.sub_products.forEach((item)=>{
                if(item.color_id == this.selectedColor){
                    this.product.sizes.forEach((size)=>{
                        if (size.id == item.size_id){
                            size.disabled = false;
                        }
                        if (size.disabled == true && size.id == this.selectedSize){
                            this.selectedSize = size.id;
                        }
                    });
                    this.product.designs.forEach((design)=>{
                        if (design.id == item.design_id){
                            design.disabled = false;
                        }
                        if (design.disabled == true && design.id == this.selectedDesign){
                            this.selectedDesign = design.id;
                        }
                    })
                }
                if(item.size_id == this.selectedSize){

                }
            });
        }
    },
    methods:{
        getProduct: async function(){
            this.spinning = true;
            var response = await HTTPRequest.getRequest(this.endPoint + 'sales_channel_products/'+this.$route.params.id+'?sales_channel_id='+this.salesChannelId , null)
            console.log(response);
            this.product= response;
            this.product.quantity = 1;
            this.spinning = false;
        },
        addToCart:async function(){
            var productIndex = -1;
            switch (this.product.product_type) {
                case "M":
                    var color_status = false,size_status = false, design_status = false; 
                    color_status = this.product.colors!=null ? true : false
                    size_status = this.product.sizes!=null ? true : false
                    design_status = this.product.designs!=null ? true : false
                    switch (true) {
                        case (color_status && size_status && design_status):
                            var subProductIndex = this.product.sub_products.findIndex(x=> x.size_id == this.selectedSize && x.color_id == this.selectedColor && x.design_id == this.selectedDesign)
                        break;
                        case (!color_status && size_status && design_status):
                            var subProductIndex = this.product.sub_products.findIndex(x=> x.size_id == this.selectedSize && x.design_id == this.selectedDesign)
                        break;
                        case (color_status && !size_status && design_status):
                            var subProductIndex = this.product.sub_products.findIndex(x=> x.color_id == this.selectedColor && x.design_id == this.selectedDesign)
                        break;
                        case (color_status && size_status && !design_status):
                            var subProductIndex = this.product.sub_products.findIndex(x=> x.size_id == this.selectedSize && x.color_id == this.selectedColor)
                        break;
                        case (!color_status && !size_status && design_status):
                            var subProductIndex = this.product.sub_products.findIndex(x=> x.design_id == this.selectedDesign)
                        break;
                        case (color_status && !size_status && !design_status):
                            var subProductIndex = this.product.sub_products.findIndex(x=> x.color_id == this.selectedColor)
                        break;
                        case (!color_status && size_status && !design_status):
                            var subProductIndex = this.product.sub_products.findIndex(x=> x.size_id == this.selectedSize)
                        break;
                        default:
                        break;
                    }
                    if (subProductIndex>=0){
                        if(this.customerLoginStatus){
                            productIndex = this.OrderListData.findIndex(x=> x.product_id == this.product.sub_products[subProductIndex].id)
                            if (productIndex >=0){
                                var id = this.OrderListData[productIndex].id
                                var quantity = this.OrderListData[productIndex].quantity + this.quantity
                                var put_request = await HTTPRequest.putRequest(this.endPoint + 'sales_channel_cart_items/' +id, null, {quantity:quantity}) 
                                if (put_request["error"] == undefined){
                                    await this.OrderList()
                                    this.$emit('getOrderCount', this.OrderListData)
                                }
                            }else{
                                var cartItemPayLoad = {
                                    cart_item:{
                                        customer_id:secureStorage.getItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-CustomerDetailsLogin").id,
                                        quantity: this.quantity,
                                        product_id:this.product.sub_products[subProductIndex].id,
                                        sales_channel_id:this.product.sales_channel_id,
                                    }
                                }
                                var post_request = await HTTPRequest.postRequest(this.endPoint + 'sales_channel_cart_items', null, cartItemPayLoad) 
                                if (post_request["error"] == undefined){
                                    await this.OrderList()
                                    this.$emit('getOrderCount', this.OrderListData)
                                }
                            }
                        }else{
                            productIndex = this.OrderListData.findIndex(x=> x.id == this.product.sub_products[subProductIndex].id)
                            if (productIndex >=0){
                                this.OrderListData[productIndex].quantity+=this.product.quantity
                            }else{
                                this.product.sub_products[subProductIndex].quantity = this.product.quantity
                                this.OrderListData.push(this.product.sub_products[subProductIndex])
                                this.successMessage = "Just Added to your cart : "+this.product.name
                            }
                            secureStorage.setItem("OrderListData"+secureStorage.getItem("SalesChannelDetails").name,this.OrderListData)
                            this.$emit('getOrderCount', this.OrderListData)
                        }
                    }
                break;
                default:
                    if(this.customerLoginStatus){
                        productIndex = this.OrderListData.findIndex(x=> x.product_id == this.product.product_id)
                        if (productIndex>=0){
                            var id = this.OrderListData[productIndex].id
                            var quantity = this.OrderListData[productIndex].quantity + this.quantity
                            var put_request = await HTTPRequest.putRequest(this.endPoint + 'sales_channel_cart_items/' +id, null, {quantity:quantity}) 
                            if (put_request["error"] == undefined){
                                await this.OrderList()
                                this.$emit('getOrderCount', this.OrderListData)
                            }
                        }else{
                            var cartItemPayLoad = {
                                cart_item:{
                                    customer_id:secureStorage.getItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-CustomerDetailsLogin").id,
                                    quantity: this.quantity,
                                    product_id:this.product.product_id,
                                    sales_channel_id:this.product.sales_channel_id,
                                }
                            }
                            var post_request = await HTTPRequest.postRequest(this.endPoint + 'sales_channel_cart_items', null, cartItemPayLoad) 
                            if (post_request["error"] == undefined){
                                await this.OrderList()
                                this.$emit('getOrderCount', this.OrderListData)
                            }
                        }
                    }else{
                        productIndex = this.OrderListData.findIndex(x=> x.id == this.product.id)
                        if (productIndex>=0){
                            this.OrderListData[productIndex].quantity+=this.quantity
                        }else{
                            this.product.quantity = this.quantity;
                            this.OrderListData.push(this.product)
                            this.successMessage = "Just Added to your cart : "+this.product.name
                        }
                        secureStorage.setItem("OrderListData"+secureStorage.getItem("SalesChannelDetails").name,this.OrderListData)
                        this.$emit('getOrderCount', this.OrderListData)
                    }
                break;
            }
        },
        formatPrice: function(value) {
            let val = (value/1).toFixed(2).replace('.', ',')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
        },
        buyItNow:function(){
            this.addToCart()
            this.checkoutOrderListData.push(this.product)
            secureStorage.setItem("CheckoutOrderListData"+secureStorage.getItem("SalesChannelDetails").name,this.checkoutOrderListData)
            this.$router.push({ name: 'checkout', params:{storeId:this.$route.params.storeId}})
        },
        updateQty:function(value){
            this.quantity = parseInt(this.quantity)+parseInt(value)
        },
        changeQty:function(event){
            this.quantity = parseInt(event.target.value)
        },
        formatPrice: function(value) {
            let val = (value/1).toFixed(2).replace('.', '.')
            return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
        },
        OrderList: async function(){
            if (this.customerLoginStatus){
                var response = await HTTPRequest.getRequest(this.endPoint + 'sales_channel_cart_items?account_id='+this.storeDetails.account_id+'&sales_channel_id='+this.storeDetails.id+'&customer_id='+secureStorage.getItem(this.storeDetails.account_id+'-'+this.storeDetails.name+"-CustomerDetailsLogin").id, null)
                console.log(response)
                this.OrderListData = response;
            }else{
                var gData = secureStorage.getItem("OrderListData"+this.storeDetails.name);
                if (gData !='' && gData !=null){
                    this.OrderListData = gData;
                    this.totalAmount = 0;
                }
            }
        },
    }
};
</script>
<style>
    .section-shaped .shape.shape-skew+.shape-container {
        padding-bottom: 0px!important;
    }
    .quantity::-webkit-outer-spin-button,
    .quantity::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
    }
</style>